import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Отправка на сборку",
    overflow: false,
    loading: _ctx.loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_select, {
        name: "Выберите контейнеры (не обязательно)",
        value: _ctx.state.containerIds,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.containerIds) = $event)),
        placeholder: "Выберите из списка",
        options: _ctx.containers_state.list,
        loading: _ctx.containers_state.is_loading,
        failed: _ctx.containers_state.is_failed,
        disabled: _ctx.loading,
        "error-text": "При получении списка контейнеров произошла ошибка",
        label: "title",
        "search-without-refresh": "",
        multiselect: ""
      }, null, 8, ["value", "options", "loading", "failed", "disabled"])
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}